import { memo } from 'react'

import Logo from '@/atoms/Logo'
import MenuToggle from '@/atoms/MenuToggle'
import Search from '@/organisms/Header/includes/Navigation/includes/Search'
import useModalStore, { showModal } from '@/store/slices/modal'

function Navigation() {
  const { name } = useModalStore((state) => state)
  const isVisible = name === 'well_being_mobile_menu'

  const showMenu = () => {
    showModal('well_being_mobile_menu')
  }

  return (
    <nav className="py-3 lg:py-3 flex flex-wrap items-center justify-center md:justify-between lg:justify-start lg:flex-nowrap bg-[#85cfc3]">
      <div className="relative flex box">
        <MenuToggle onShow={showMenu} isVisible={isVisible} />
        <div className="relative flex flex-col items-center justify-between flex-1 md:space-x-4 md:mx-8 lg:mx-0 md:flex-row">
          <Logo className="text-white hover:text-violet-5 max-w-[82px] lg:max-w-[96px] mb-0.5 lg:mb-1" />
          <Search />
        </div>
      </div>
    </nav>
  )
}

export default memo(Navigation)
